import { render, staticRenderFns } from "./SliderColaboradores.vue?vue&type=template&id=ecc55f98&scoped=true"
import script from "./SliderColaboradores.vue?vue&type=script&lang=js"
export * from "./SliderColaboradores.vue?vue&type=script&lang=js"
import style0 from "./SliderColaboradores.vue?vue&type=style&index=0&id=ecc55f98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecc55f98",
  null
  
)

export default component.exports